import { useFormContext } from '@calendly/form'
import { I18n } from '@calendly/i18n'
import { Button } from '@calendly/ui/components/button'
import { ArrowSyncIcon } from '@calendly/ui/components/icons'
import { useSelector } from 'react-redux'

import { useUpgradeSubscription } from 'components/billing/use_upgrade_subscription'
import { isAvailableFeatureSelector } from 'features/billing'

import { useUserPoolSidePanelActions } from './user_pool_side_panel/context'
import { useCreateUserPool } from '../../hooks'

export const CreateUserPoolButton = () => {
  const isCollectiveRoundRobinFeatureAvailable = useSelector(
    (state) => isAvailableFeatureSelector(state, { featureKey: 'collective_round_robin_event_types' })
  )

  const { isSubmitting } = useFormContext()
  const { openUserPoolSidePanel } = useUserPoolSidePanelActions()
  const upgradeSubscription = useUpgradeSubscription({ featureKey: 'collective_round_robin_event_types' })
  const createUserPool = useCreateUserPool()

  const handleCreateUserPool = () => {
    if (!isCollectiveRoundRobinFeatureAvailable) {
      upgradeSubscription()
    } else {
      const { isCreated, newUserPool } = createUserPool()

      if (isCreated) {
        openUserPoolSidePanel({ userPoolUid: newUserPool?.key, minHeight: '800px' })
      }
    }
  }

  return (
    <Button
      size="small"
      decoration="ghost"
      responsive={false}
      onClick={handleCreateUserPool}
      disabled={isSubmitting}
    >
      <ArrowSyncIcon />
      {I18n.t('publisher.event_type_editor.sections.hosts.round_robin.create_pool')}
    </Button>
  )
}
